export const setParamsKeyName = (key, isTableView) => {
  return isTableView ? key : `filter_${key}`;
}